<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Rozliczenia'" [name]="'Szablon email'"></app-breadcrumb>
<div class="risk-configuration-add" fxLayout="column" fxLayoutGap="15px"  >
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!templateForm.valid || buttonValid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card fxLayout="column" fxFlex="100">
        <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" fxLayoutAlign="center center">
          <div  fxFlex="25" >
            <app-month-picker
              fxFlex="100"
              label="Miesiąc rozliczeniowy" [required]="true"
              [control]="billingMonthControl"
            ></app-month-picker>
          </div>
          <div  fxFlex="25" >
            <app-dict
              [label]="'Firma'" [dictType]="'company'"
              [control]="companyControl"
              [required]="true"
              [multiple]="false"
            ></app-dict>
          </div>
          <div fxFlex="25">
            <app-dict
              [label]="'Rodzaj rozliczenia'" [dictType]="'type_of_settlement'"
              [control]="typeOfSettlementControl"
              [required]="true"
              [multiple]="false"
            ></app-dict>
          </div>
          <div fxFlex="25">
            <button (click)="download()" [disabled]="!billingMonthControl.value || !companyControl.value || !typeOfSettlementControl.value" mat-stroked-button color="primary"><mat-icon>download</mat-icon> <span> Pobierz</span></button>
          </div>
        </div>
      </mat-card>
    </div>
  </div>


  <ng-container *ngIf="editor">
    <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
      <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
        <mat-card>
          <div fxLayout="row" fxLayoutAlign="space-between center" >
            <h3>Aktualny szablon</h3>
            <button (click)="copy()" [disabled]="!billingMonthControl.value || !companyControl.value || !typeOfSettlementControl.value" mat-stroked-button color="primary"><mat-icon>content_copy</mat-icon> <span> Wklej treść z miesiąca poprzedniego</span></button>
          </div>
          <div fxLayout="row">
            <angular-editor fxFlex="100"  [config]="editorConfig" [formControl]="contentControl"></angular-editor>
          </div>

        </mat-card>
      </div>
    </div>
  </ng-container>
  <div fxLayout="row" fxFlex.lt-md="100%" >
    <div fxFlex="100">
      <mat-card>
        <div fxLayout="row">
          <h3>Dodanie kwoty rozliczenia do treści maila</h3>
        </div>

        <div fxLayout="column">
          {{temp}}
        </div>
      </mat-card>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!templateForm.valid || !buttonValid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
  </div>
</div>
